import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const shots = [
  {
    url: "https://images.unsplash.com/photo-1572294832787-f864aa3cff44?auto=format&fit=crop&w=1200&q=80",
    label: "abarrotes",
    tag: "01",
    caption: "La miscelánea de la esquina.",
    span: "md:col-span-5 md:row-span-2",
    h: "h-[420px] md:h-[640px]",
  },
  {
    url: "https://images.unsplash.com/photo-1566657817181-c69e4a8eeb1e?auto=format&fit=crop&w=900&q=80",
    label: "refrescos",
    tag: "02",
    caption: "Coca fría, cerveza al tiempo.",
    span: "md:col-span-4",
    h: "h-[300px] md:h-[310px]",
  },
  {
    url: "https://images.unsplash.com/photo-1617859047277-9f47d2bd9696?auto=format&fit=crop&w=900&q=80",
    label: "pan dulce",
    tag: "03",
    caption: "El pan de todos los días.",
    span: "md:col-span-3",
    h: "h-[300px] md:h-[310px]",
  },
  {
    url: "https://images.unsplash.com/photo-1608686207856-001b95cf60ca?auto=format&fit=crop&w=900&q=80",
    label: "papelería",
    tag: "04",
    caption: "Cuaderno profesional. Regreso a clases.",
    span: "md:col-span-3",
    h: "h-[300px] md:h-[320px]",
  },
  {
    url: "https://images.unsplash.com/photo-1513639776629-7b61b0ac49cb?auto=format&fit=crop&w=900&q=80",
    label: "fondas",
    tag: "05",
    caption: "Comida corrida. Cobro por voz.",
    span: "md:col-span-4",
    h: "h-[300px] md:h-[320px]",
  },
];

export default function Photography() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [-40, 40]);

  return (
    <section
      id="giros"
      ref={ref}
      className="relative py-24 md:py-32 bg-[#050505]"
      data-testid="photography"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16">
          <div className="md:col-span-3">
            <p className="font-mono text-[11px] tracking-[0.3em] text-white/40 uppercase">
              / Para quién
            </p>
          </div>
          <div className="md:col-span-9 flex items-end justify-between">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1 }}
              className="font-display text-4xl md:text-6xl tracking-tighter leading-[0.95] max-w-3xl"
            >
              Una plataforma. <span className="text-white/40">Todos los giros.</span>
            </motion.h2>
            <p className="hidden md:block font-mono text-xs text-white/40 tracking-widest">
              05 · SECTORES CUBIERTOS
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5">
          {shots.map((s, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: 0.9,
                delay: i * 0.08,
                ease: [0.22, 1, 0.36, 1],
              }}
              className={`relative overflow-hidden rounded-2xl border border-white/10 group ${s.span} ${s.h}`}
              data-testid={`photo-${s.tag}`}
            >
              <motion.img
                src={s.url}
                alt={s.label}
                loading="lazy"
                style={{ y: i === 0 ? y : 0 }}
                className="w-full h-full object-cover photo-clip group-hover:scale-[1.04]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent pointer-events-none" />
              <div className="absolute top-4 left-4 flex items-center gap-2">
                <span className="chip !bg-black/60 !border-white/20">{s.tag}</span>
                <span className="chip !bg-black/60 !border-white/20">{s.label}</span>
              </div>
              <figcaption className="absolute bottom-4 left-4 right-4">
                <p className="font-display text-lg md:text-2xl tracking-tight text-white leading-tight">
                  {s.caption}
                </p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
